<script>
import store from '@/plugins/store';

export default {
  data() {
    return {
      pageTabs: [
        {
          name: 'In Bound',
          badge: '',
        },
        {
          name: 'In Stock',
          badge: '',
        },
        {
          name: 'In process',
          badge: '',
        },
        {
          name: 'Ready for shipment',
          badge: '',
        },
        {
          name: 'Processing',
          badge: '',
        },
        {
          name: 'Shipped',
          badge: '',
        },
        {
          name: 'Ready for utilize',
          badge: '',
        },
        {
          name: 'Utilized',
          badge: '',
        },
      ],
      interval: null,
    };
  },
  watch: {
    user_badges() {
      this.updateBadges();
    },
  },
  computed: {
    user_role() {
      return this.$store.state.users.role;
    },
    user_badges() {
      return this.$store.state.users.user_badges;
    },
    chosen_client() {
      return this.$store.state.users.chosen_client;
    },
    badge_loading() {
      return this.$store.state.users.badge_loading;
    },
    app_section() {
      return this.$store.getters.get_app_section;
    },
    getSectionAccess() {
      return this.$store.getters.getSectionAccess;
    },
    client_id() {
      return this.$store.getters.client_id;
    },
    preparedPageTabs() {
      return this.pageTabs.map((tab) => {
        tab.link = `${this.app_section}-${tab.name.split(' ').join('-').toLowerCase()}`;
        return tab;
      });
    },
  },
  created() {
    store.commit('set_app_section', 'storage');

    if (this.client_id && this.getSectionAccess.indexOf(this.app_section) === -1) {
      this.$router.push({ name: 'storage' });
      return;
    }
    if (this.client_id) {
      store.dispatch('subscribe_badges', this.client_id);
      return;
    }
    if (this.chosen_client) {
      store.dispatch('subscribe_badges', this.chosen_client);
    }
  },
  methods: {
    updateBadges() {
      if (this.user_badges === null) return;

      this.pageTabs.forEach((tab) => {
        if (tab.name === 'In Bound') tab.badge = this.user_badges.inbound;
        if (tab.name === 'In Stock') tab.badge = this.user_badges.instock;
        if (tab.name === 'In process') tab.badge = this.user_badges.inprocess;
        if (tab.name === 'Ready for utilize') tab.badge = this.user_badges.ready_for_utilize;
        if (tab.name === 'Utilized') tab.badge = this.user_badges.utilized;
        if (tab.name === 'Ready for shipment') tab.badge = this.user_badges.ready_for_shipment;

        if (tab.name === 'Processing') {
          tab.badge = Object.entries(this.user_badges.processing)
            .map((entries) => {
              if (entries[0] === 'fba' || entries[0] === 'fbm') return entries[1];
              return null;
            })
            .filter((item) => item !== null);
        }

        if (tab.name === 'Shipped') {
          tab.badge = Object.entries(this.user_badges.shipped)
            .map((entries) => entries[1]);
        }
      });
    },
  },
};
</script>
<template src="./s-storage.pug" lang="pug"></template>
